
export default {
  computed: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  beforeRouteUpdate (to, from, next) {
    // Navigating to same component, but different route
    const itemEditor = this.$refs && this.$refs.itemEditor
    // Check with item editor if we should leave
    if (itemEditor && itemEditor.beforeParentRouteChange) {
      itemEditor.beforeParentRouteChange(to, from, next, this.showItemOnly)
    } else {
      console.log('No item editor')
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    // Navigating to different component
    const itemEditor = this.$refs && this.$refs.itemEditor
    // Check with item editor if we should leave
    if (itemEditor && itemEditor.beforeParentRouteChange) {
      itemEditor.beforeParentRouteChange(to, from, next, this.showItemOnly)
    } else {
      console.log('No item editor')
      next()
    }
  }
}
